import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { waLink } from "@/lib/content";

export const WhatsAppFloat = () => {
  const { content } = useContent();
  return (
  <motion.a
    href={waLink(content.business.whatsapp_number, content.hero.whatsapp_msg)}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.5 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.6, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    className="whatsapp-pulse fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)]"
    data-testid="whatsapp-float-button"
    aria-label="Chat with us on WhatsApp"
  >
    <MessageCircle size={26} />
  </motion.a>
  );
};
